<template>
    <v-modal :is-open="isOpen"
        type="reviews"
        class="bg-white"
        @close="$emit('close')">
        <v-modal-header @close="$emit('close')">
            {{ t('review-title') }}
        </v-modal-header>

        <div class="px-lg pb-20">
            <p class="text-base tracking-xl">
                {{ t('review-content') }}
            </p>

            <v-page-product-rating-widget :sku="sku"
                :skus="skus" />
        </div>
    </v-modal>
</template>

<script lang="ts" setup>
defineProps<{
    isOpen: boolean
    sku: string
    skus: string[]
}>();

defineEmits<{
    (event: 'close'): void
}>();

const { t } = useI18n();
</script>

<i18n lang="json">
{
    "et": {
        "review-title": "Arvustused",
        "review-content": "Siit leiate kõik toodete arvustused"
    },
    "fi": {
        "review-title": "Arvostelut",
        "review-content": "Täältä löydät kaikki tuotteen arvostelut!"
    }
}
</i18n>
